<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_titleBack enjoy">
      <div class="attach_subtitle">
        <h1>파운틴 라운지</h1>
        <p>파운틴Ⅳ, Ⅴ 회원만을 위한 특별한 공간</p>
      </div>
    </div><!--rew19_titleBack--> 
    <!--TODO : 구현필요-->
    <div class="rew19_contents_inner">
      <h3 class="rew19_titleVip">파운틴 라운지 이벤트</h3>
        
        <div class="rew19-table-wrap">

          <table class="rew19-table-row">

            <caption>콜 테이블</caption>

            <tbody class="detail">

            <tr>
              <td class="table-row__head align-left">이벤트 제목</td>
              <td class="table-row__data align-left"><span class="detail-title">enJoy 멤버십 론칭 기념 룰렛 이벤트</span></td>
            </tr>

            <tr>
              <td class="table-row__head align-left">이벤트 기간</td>
              <td class="table-row__data align-left">2019.12.03 ~ 2019.12.31</td>
            </tr>

            <tr>
              <td class="table-row__data align-left contents" colspan="2">
                안녕하세요!<br>
                enJoy 멤버십 론칭 기념 룰렛 이벤트를 안내 드립니다.<br>
                <br>
                파운틴 IV, V 회원만을 위한 파운틴 라운지 룰렛 이벤트!<br>
                지금 바로 아래 링크를 클릭하여 참여하세요.<br>
                <br>
                enJoy 멤버십 론칭 기념 룰렛 이벤트<br>
                - 대 상 : 12월 기준 파운틴 IV, V 회원<br>
                - 기 간 : 12월 3일 ~ 12월 31일까지<br>
                * 회원 ID당 1회만 참여 가능하며, 당첨된 상품은 2020년 1월 정기구매 첫 결제 주문에 포함되어 배송됩니다.<br>
                * 2020년 1월 정기구매 주문이 없는 경우(철회, 결제 취소 등), 당첨된 상품은 배송되지 않습니다.<br>
                <br>
                이벤트 상품 정보<br>
                - [NEW]에이지락 페이스 갈바닉 스파+ : 20명<br>
                - 발효 홍삼 프리미엄 15일 : 800명<br>
                - 에이지락 트루 페이스 에센스 울트라 7 days : 2,000명<br>
                - 뉴스킨180° 프렙 앰플 7 days : 2,000명<br>
                <br>
                감사합니다<br>
                <br>

                <div class="areaImage">
                  <a href='/app/ro/promotion/roulette' target="_blank"><img src="https://resource2018.nuskinkorea.co.kr/images/aro/btn_roulette.png"></a>
                </div>
              </td>
            </tr>

          </tbody>
        </table>
        <div class="rew19-btn-center">
          <router-link :to="$aroBasePath+'/vipList'"
            class="rew19_btn_border">목록</router-link>
        </div>
      </div>
    </div><!--rew19_contents_inner-->
  </div><!--rew19_aro_wrap-->        
</template>
<script>
import AroBase from '@/components/base/AroBase';
export default {
  name: "vipDetail",
  extends: AroBase,
  computed: {
    isNuskinChannel: function() {
      return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
    },
    isMeCommerceChannel : function(){
      return this.$aroChannel == Const.ARO_CHANNEL_ME_COMMERCE;
    }
  },
  props: {    
  },
  data: () => ({
    //View Data
    viewData : {
      memberShip :{
        // aroBuyCount: 11
        // buyPeriod: "11",
        // couponCount: "0",
        // dueDate: "2019-10-01",
        gradeCode: "0",
        // gradeName: "파운틴Ⅱ",
        // isUseAro: "Y",
        // message: "조회성공",
        // nextGradeCode: "2",
        // nextGradeName: "파운틴Ⅲ",
        // startDate: "2019-04-30",
        // status: "0000",
        // vipDueDate: "2020-04-01",
        couponCount: 0,
      },
    },
  }),
  created() {
    let _this = this;
  },
  mounted() {
    let _this = this;

    _this.initUI();

    _this.loadData();
  },
  methods: {    
    /**
     * JQuery UI
     */
    initUI : function(){
      
    },

    /**
     * API Request
     */
    //멤버쉽 정보 가져오기
    apiGetMemberShips : function(){
      let _this = this;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/memberships`, {
        params: {}
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadData : function(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetMemberShips().then(res=>{
        
        if (res.status === 200 && res.data.status === "0000") {
          //success

          _this.viewData = {
            ..._this.viewData,
            memberShip : {...res.data}
          };

        }else{
          //Fail
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }      

        if(!("3" == _this.viewData.memberShip.gradeCode || "4" ==_this.viewData.memberShip.gradeCode)){
          let errMsg = "파운틴 라운지는 enJoy 멤버십 파운틴 IV, V 이상 회원만 입장할 수 있습니다.";
          _this.$dialogs.alert(errMsg)
          .then(res => {
            location.href="/app/ro/aroShop/memberShip";
          });
        }
      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },
  } 
}
</script>
<style>
a.rew19_btn_border{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/my/njoy/vipDetail.vue